module.exports = __webpack_public_path__ + "img/43.8cb9a844.jpg";